// extracted by mini-css-extract-plugin
export default {"link":"LeftMenuItem_link_l0F5c","icon":"LeftMenuItem_icon_RE8am","label":"LeftMenuItem_label_NJn29","isActive":"LeftMenuItem_isActive_uJT5L"};